<app-header></app-header>
<ion-content class="gray-content-bg">
  <div
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    class="image-background"
  >
    <ion-grid class="image-title-grid">
      <ion-row class="image-title-row">
        <ion-col>
          <ion-text class="image-title">
            {{ 'i18n.scoop.imageHeaderText' | translate }}
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <div
    class="layout"
    [ngClass]="
      platformService?.platformType === platformService?.platformEnum?.desktop
        ? 'desktop'
        : platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
    "
  >
    <img
      class="scoop-logo"
      [ngClass]="
        platformService?.platformType === platformService?.platformEnum?.desktop
          ? 'desktop'
          : platformService?.platformType === platformService?.platformEnum?.tablet
          ? 'tablet'
          : 'mobile'
      "
      src="assets/images/scoop-logo.png"
    />
    <div
      class="description-text-box"
      [ngClass]="
        platformService?.platformType === platformService?.platformEnum?.desktop
          ? 'desktop'
          : platformService?.platformType === platformService?.platformEnum?.tablet
          ? 'tablet'
          : 'mobile'
      "
    >
      <div class="description">
        <h4
          [class.mobile]="
            platformService?.platformType === platformService?.platformEnum?.mobile
          "
        >
          {{ 'i18n.scoop.descriptionHeader' | translate }}
        </h4>
        <div [style.display]="isDescriptionExpanded ? 'block' : 'none'">
          <p>{{ 'i18n.scoop.descriptionTextOne' | translate }}</p>
          <p>{{ 'i18n.scoop.descriptionTextTwo' | translate }}</p>
        </div>
      </div>
      <div class="view-more" (click)="expandDescription()">
        <div>
          {{ isDescriptionExpanded ? ('i18n.common.viewLess' | translate) :
          ('i18n.common.viewMore' | translate) }}
        </div>
        <ion-icon
          *ngIf="!isDescriptionExpanded"
          name="chevron-down-outline"
          class="chevron"
        ></ion-icon>
        <ion-icon
          *ngIf="isDescriptionExpanded"
          name="chevron-up-outline"
          class="chevron"
        ></ion-icon>
      </div>
    </div>
    <ng-container *ngIf="(sneakPeeks$ | async) as sneakPeeks">
      <app-scoop-product-preview
        *ngIf="sneakPeeks?.length > 0"
        class="scoop-products"
        [sneakPeekProducts]="sneakPeeks"
        (productClick)="onProductClick($event)"
      >
      </app-scoop-product-preview>
    </ng-container>
  </div>
  <app-footer></app-footer>
</ion-content>
